<template>
  <!-- eslint-disable vue/no-unused-refs -->
  <AppBarLayout>
    <template #default>
      <div class="main tw-overflow-x-hidden">
        <ActivePathWrapper
          :active-hierarchy="[
            getComponentUiText('app-menu-assess-1'),
            getComponentUiText('app-menu-submenu-assess-vendor-assessments-1'),
          ]"
        />
        <div
          :class="`tw-bg-[#fff] xl:tw-px-[60px] tw-px-[10px] xl:tw-py-[55px] tw-py-[30px]`"
        >
          <div
            style="line-height: 22px"
            class="title tw-text-2xl tw-font-semibold tw-text-[#211F58] tw-text-[22px]"
          >
            {{
              getComponentUiText("app-menu-submenu-assess-vendor-assessments-1")
            }}
          </div>
        </div>
        <div
          ref="containerRef"
          :class="`content-wrapper ${isMenuPin ? 'content-wrapper-pin' : ''}`"
        >
          <div
            id="click-box-assessment"
            :style="{
              order: !isStacked ? 1 : 2,
            }"
            :class="`tw-gap-0 content assessment-container 
              assessment-container-pin content-pin
            `"
          >
            <div class="assessment-content">
              <div id="vendor-assess-manage-requested">
                <!-- title and bulk action -->
                <div
                  class="title-container tw-flex tw-items-center tw-justify-between"
                >
                  <p class="tw-my-0">
                    <span class="title tw-mr-[10px]">{{
                      getComponentUiText("app-vendor-assessment-title-1")
                    }}</span>
                  </p>
                  <div
                    id="vendor-assess-manage-group-button"
                    class="group-button tw-flex tw-items-center"
                  >
                    <ButtonBulkActions
                      :id-popover="'vendor-assessment-manage-builk-btn'"
                      :active="assessmentSelected?.length >= 1"
                      :selected-number="assessmentSelected.length"
                      button-class="!tw-mr-[20px]"
                    />
                    <ButtonFilter
                      :active="false"
                      :id-popover="'vendor-assessment-manage-filter-btn'"
                      button-class="!tw-mr-[20px]"
                    />

                    <div
                      id="manage-vendor-display-settings popover-target-1"
                      data-cy="vendor-assessment-display-settings"
                      class="toggle-switch-view tw-relative tw-px-[14px] tw-py-[10px] !tw-mr-[20px]"
                      :class="
                        isCheckToggleDisplayOptions
                          ? 'setting-option-selected'
                          : ''
                      "
                      @click="openPopoverDisplayOption"
                      @mouseover="isHoverDisplayOptions = true"
                      @mouseout="isHoverDisplayOptions = false"
                    >
                      <label class="tw-cursor-pointer">
                        <span class="">
                          <img
                            v-if="isCheckToggleDisplayOptions"
                            src="@/assets/img/setting_option_selected.svg"
                            alt=""
                          />
                          <img
                            v-else-if="
                              !isShowToolTipDisplayOptions &&
                              !isHoverDisplayOptions
                            "
                            src="@/assets/img/setting_option.svg"
                            alt=""
                          />
                          <img
                            v-else
                            src="@/assets/img/setting_option_active.svg"
                            alt=""
                          />
                        </span>
                      </label>
                    </div>

                    <b-popover
                      ref="popover_display_options"
                      target="manage-vendor-display-settings popover-target-1"
                      placement="bottom-end"
                      click="true"
                      :offset="20"
                      style="max-width: 290px !important"
                      :custom-class="`custom-actions-popover assessment-display-options`"
                      class="tw-absolute"
                      @show="isShowToolTipDisplayOptions = true"
                      @hidden="isShowToolTipDisplayOptions = false"
                    >
                      <AssessmentDisplayOptions
                        :list-option="displayOptions"
                        :class="'!tw-w-[290px]'"
                      />
                    </b-popover>

                    <IconButton
                      id="vendor-assess-manage-btn-open-modal-create"
                      data-cy="add-new-vendor-assessment-btn"
                      src="/img/plus_icon.svg"
                      @click="openModalCreateVendorAssessment"
                    />
                  </div>
                </div>

                <!-- Information -->
                <div
                  v-if="checklistDetailData.length"
                  class="tw-flex tw-flex-col tw-gap-[25px] tw-mt-[20px] tw-w-full tw-rounded-[6px]"
                >
                  <div
                    v-if="isChecklistDetailLoading"
                    class="custom-global-skeleton tw-w-full tw-h-[72px] tw-rounded-[6px]"
                  ></div>
                  <VendorAssessmentDetails
                    v-for="(item, index) in checklistDetailData"
                    v-else
                    :key="item.checklistId || item.dateUpdated"
                    :details="item"
                    :index="index"
                    :checklist-id="item.checklistId"
                    @select:assessment="handleSelectAssessment"
                    @loaded="() => {}"
                    @on-refresh="() => {}"
                  />
                </div>
                <div
                  v-else
                  class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-[20px] tw-my-[20px]"
                >
                  <NoteInfo
                    v-if="notInfoVisible && totalRequestedChecklistArchived"
                    @close="() => (notInfoVisible = false)"
                  >
                    <span
                      class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]"
                      >{{
                        getComponentUiText(
                          "app-component-assessments-vendor-assessment-no-asessment-note-info-1",
                        )
                      }}</span
                    >
                  </NoteInfo>
                  <div
                    class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-py-[50px] tw-px-[25px] tw-gap-[20px] tw-rounded-[6px] tw-bg-[#FFF]"
                  >
                    <p
                      class="tw-m-0 tw-text-[#878787] tw-text-[15px] tw-leading-[145%] tw-font-normal"
                    >
                      {{
                        getComponentUiText(
                          "app-component-assessments-vendor-assessment-no-asessment-description-1",
                        )
                      }}
                    </p>
                    <p
                      class="tw-m-0 tw-text-[#387DFF] tw-text-[11px] tw-leading-[145%] tw-font-medium tw-cursor-pointer"
                      @click="openModalCreateVendorAssessment"
                    >
                      {{
                        getComponentUiText(
                          "app-component-assessments-vendor-assessment-no-asessment-action-1",
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Assessment Template -->
              <div
                id="vendor-assess-manage-template"
                :class="`${
                  checklistDetailData.length ? 'tw-mt-[40px]' : 'tw-mt-[0px]'
                }`"
              >
                <VendorAssessmentTemplate @refresh="init" />
              </div>

              <!-- Button Create assessment -->
              <div class="tw-mt-[40px]">
                <AssessmentCreateButton
                  id="vendor-assess-manage-btn-create"
                  data-cy="vendor-assess-manage-send-new-assessment-btn"
                  :title="`
                    ${
                      checklistDetailData.length
                        ? getComponentUiText(
                            'app-component-assessments-vendor-assessment-send-a-new-assessment-1',
                          )
                        : getComponentUiText(
                            'app-component-assessments-vendor-assessment-create-your-first-vendor-assessment-1',
                          )
                    }
                  `"
                  :btn-style="'tw-px-[25px] tw-py-[16px]'"
                  @click="openModalCreateVendorAssessment"
                />
              </div>
            </div>
          </div>
          <div
            :class="`tw-h-[fit-content] action-width tw-min-w-[261px] tw-w-[420px] tw-flex tw-items-center tw-flex-col ${
              !isStacked ? 'tw-order-2' : 'tw-order-1 !tw-pt-0'
            }`"
          >
            <!-- <ActionButton :profile-actions="profileActions" /> -->
            <div
              class="tw-mb-5 tw-py-[8px] tw-w-full tw-flex tw-justify-between tw-items-center tw-text-[#211F58] tw-text-[18px] tw-font-semibold tw-leading-[100%]"
            >
              {{
                getComponentUiText(
                  "app-component-assessments-vendor-mini-dash-title-1",
                )
              }}
              <IconButton
                id="vendor-assess-manage-btn-open-modal-create"
                data-cy="add-new-vendor-btn"
                src="/img/plus_icon.svg"
                @click="openModalAddVendorAssessment"
              />
            </div>
            <div
              v-if="providerData && providerData.length"
              class="tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-border-solid tw-border-[1px] tw-border-[#EFF0F1] action-width tw-rounded-[6px] tw-min-w-[261px] tw-w-[420px] tw-flex tw-flex-col tw-items-center tw-justify-center"
            >
              <ProviderMinidash :data="providerData" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </AppBarLayout>
</template>

<script lang="ts" setup>
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import IconButton from "@/components/common/iconButton.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import { getComponentUiText } from "@/utils/utilities";
import ProviderMinidash from "@/components/vendor/providerMinidash.vue";
import store from "@/store";
import VendorAssessmentDetails from "@/components/vendor/vendorAssessmentDetails.vue";
import AssessmentCreateButton from "@/components/assessment/assessmentCreateButton.vue";
import VendorAssessmentTemplate from "@/components/vendor/vendorAssessmentTemplate.vue";
import { computed, onBeforeUnmount, onMounted, Ref, ref, watch } from "vue";
import { MODAL_NAME } from "@/utils/constants";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IModalMessage } from "@/interfaces/common/common";
import AssessmentDisplayOptions from "@/components/assessment/assessmentDisplayOptions.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import NoteInfo from "@/components/common/noteInfo.vue";
import { useRoute } from "vue-router";

const isHoverDisplayOptions: Ref<boolean> = ref(false);
const popover_display_options: any = ref(null);
const isShowToolTipDisplayOptions: Ref<boolean> = ref(false);
const isChecklistDetailLoading = ref(true);
const assessmentSelected: Ref<number[]> = ref([]);
const notInfoVisible = ref(true);
const route = useRoute();

const showDeletedAssessments: Ref<boolean> = ref(
  store.state.Vendor.isShowArchivedChecklist,
);

const checklistDetailData = computed(
  () => store.state.Vendor.requestedChecklist,
);

const providerData = computed(() => {
  const clr = [...store.state.Vendor.requestedChecklist];
  const providers = [...store.state.Vendor.listProvider];
  providers.forEach((provider) => {
    const findIndex = clr.findIndex((i) => i.providerId === provider.id);
    if (findIndex === -1) {
      clr.push({
        providerId: provider.id,
        providerName: provider.name,
        checklistRequestedHistory: [],
      });
    } else {
      clr[findIndex].providerName = provider.name;
    }
  });
  return clr;
});

const isCheckToggleDisplayOptions: Ref<boolean> = computed(
  () => showDeletedAssessments.value,
);

const displayOptions = computed(() => [
  {
    title: getComponentUiText(
      "app-component-vendor-assessment-display-options-show-deleted-1",
    ),
    value: showDeletedAssessments.value,
    action: handleShowDeletedAssessments,
    dataCy: "show-deleted-assessments",
  },
]);

const isMenuPin = computed(
  () =>
    store.state.Navigation.chevronActive && store.state.Navigation.isMenuOpen,
);

const currentOrg = computed(() => store.state.Org.currentOrg);
const totalRequestedChecklistArchived = computed(
  () => store.state.Vendor.totalRequestedChecklistArchived,
);

const containerRef: any = ref(null);
const isStacked = ref(false);
let observer: any = null;

onMounted(() => {
  const checkStacked = () => {
    const [el1, el2] = containerRef.value.children;
    requestAnimationFrame(() => {
      isStacked.value = el1.offsetTop !== el2.offsetTop;
    });
  };
  const param = route?.query?.param;
  if (param === "OpenModalCreateAssessment") {
    openModalCreateVendorAssessment();
  }
  observer = new ResizeObserver(checkStacked);
  observer.observe(containerRef.value);
  requestAnimationFrame(() => {
    checkStacked();
  });
});

onBeforeUnmount(() => {
  if (observer && containerRef.value) observer.unobserve(containerRef.value);
});

const openPopoverDisplayOption = () => {
  setTimeout(() => {
    popover_display_options?.value?.$emit("show");
  }, 500);
};

const filterChecklistArchived = () => {
  const list = store.state.Vendor.requestedChecklist;
  const result = list
    .map((i) => ({
      ...i,
      checklistRequestedHistory: i.checklistRequestedHistory.filter(
        (c) => !c.isArchived,
      ),
    }))
    .filter((item) => item.checklistRequestedHistory.length > 0);

  if (result.length === 0) return [];
  else return result.flatMap((item) => item.checklistRequestedHistory);
};

const handleShowDeletedAssessments = async () => {
  showDeletedAssessments.value = !showDeletedAssessments.value;

  await store.commit(
    "Vendor/SET_IS_SHOW_ARCHIVED_CHECKLIST",
    showDeletedAssessments.value,
  );

  // Call api GET deleted assessment or set previous assessment.
  if (showDeletedAssessments.value) {
    await store.dispatch("Vendor/fetchRequestedChecklist", {
      isArchived: true,
    });
  } else {
    await store.commit(
      "Vendor/SET_REQUESTED_CHECKLIST",
      filterChecklistArchived(),
    );
  }
};

onMounted(() => {
  init();
});

watch(
  () => currentOrg.value.orgId,
  (newVal, oldVal) => {
    if (newVal !== oldVal && newVal && oldVal) {
      isChecklistDetailLoading.value = true;
      init();
    }
  },
);

const init = async () => {
  await store.dispatch("Vendor/fetchRequestedChecklist", {
    isArchived: showDeletedAssessments.value,
  });
  await store.dispatch("Vendor/fetchRequestedTemplate");
  await store.dispatch("Vendor/fetchProviderList");
  isChecklistDetailLoading.value = false;
};

const handleSelectAssessment = (checklistId: number) => {
  if (assessmentSelected.value.includes(checklistId)) {
    assessmentSelected.value = assessmentSelected.value.filter(
      (id) => id !== checklistId,
    );
  } else {
    assessmentSelected.value = [...assessmentSelected.value, checklistId];
  }
};

const openModalCreateVendorAssessment = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_CREATE_NEW_VENDOR_ASSESSMENT,
    properties: {},
    events: {
      "update:data": () => {},
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const openModalAddVendorAssessment = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_MANAGE_VENDOR_DETAIL,
    properties: {},
    events: {
      "update:data": () => {},
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};
</script>

<style lang="scss" scoped>
#appBarLayout {
  overflow-y: hidden;
}

#body {
  flex-wrap: nowrap;
}

.main {
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
  height: 100%;
  overflow-y: auto;
}

.assessment-container {
  max-width: 70vw;
  gap: 60px;
}

.content-wrapper {
  display: flex;
  padding: 55px 60px;
  flex-wrap: wrap;
  gap: 60px;
  border-top: 1px solid var(--UI-rule, #eff0f1);
}

.assessment-container {
  .title {
    font-size: 18px;
    line-height: 100%;
    color: #211f58;
    font-weight: 600;
  }

  .sub-title {
    color: #211f58;
  }
}

.content {
  display: flex;
  .assessment-content {
    min-width: 100%;
  }
}

.invited-table {
  margin-top: 40px;
}

.table-header {
  margin-bottom: 15px;
}

.actions-button-container {
  margin-top: 40px;
  margin-bottom: 40px;
}

.header-user {
  min-width: 500px;
}

@media (max-width: 1198px) {
  .assessment-container {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
    gap: 40px;
  }

  .content {
    flex-direction: column-reverse;
  }

  .actions-button-container {
    margin-left: 0px;
  }
}
@media (max-width: 1280px) {
  .content-wrapper {
    padding: 40px 10px;
  }
}
@media (max-width: 1710px) {
  .assessment-container-pin {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
    gap: 40px;
  }

  .content-pin {
    flex-direction: column-reverse;
  }

  .actions-button-container-pin {
    margin-left: 0px;
  }
}

.toggle-switch-view {
  border-radius: 6px;
  background: var(--ui-white, #fff);
  backdrop-filter: blur(6px);
  align-items: center;
  display: inline-flex;

  label {
    margin-bottom: 0;
  }

  .label {
    display: flex;
    cursor: pointer;
    padding: 10px 18px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    color: var(--ui-light-grey, #b7b7b7);
    letter-spacing: 1px;
    border-radius: 6px;
    min-width: 16px;
  }

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;

    &:checked + .label {
      background: var(--brand-navy, #211f58);
      color: #fff;
    }
  }

  &.setting-option-selected {
    background: var(--brand-navy, #211f58);
  }
}

@media (max-width: 520px) {
  .title-container {
    gap: 10px;
    flex-direction: column;
    align-items: flex-start;
  }
}
@media screen and (max-width: 420px) {
  .action-width {
    width: 380px;
  }
}
@media (min-width: 1280px) {
  .assessment-container-pin {
    width: 1040px;
  }
}
</style>
